<template>
  <div>
    <Breadcrumb :title="'Vesting Bulk Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button class="btn btn-primary" style="float:right;" @click.prevent="downloadTemplate">
          <span class="fa fa-download"></span> Download Template
        </button>
        <button
          class="btn btn-secondary"
          style="float:right;margin-right:10px;"
          @click.prevent="backToVesting"
        >
          <span class="k-icon k-i-undo"></span> &nbsp;Back to Vesting
        </button>
      </div>
    </div>
    <div class="row">
      <br>
    </div>
    <BaseAuditDropzone
      ref="ParentFileUploaded"
      :id="'vestingBulkUpload'"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br>
    <div
      ref="refCustomerror"
      id="Customerror"
      class="alert alert-danger"
      role="alert"
      v-show="pageErrors.length"
    >
      <span v-show="pageErrors.length" class="alert-danger">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in pageErrors" :key="error">{{ error }}</li>
        </ul>
      </span>
    </div>
    <br>
    <div v-show="displayPage">
      <div class="row no-gutters">
        <div class="col">
          <div class="form-row">
            <div class="col-md-12">
              <BaseGrid
                :mode="'editform'"
                :config="VestingBulkUploadGridConfig"
                :data="dataVestingExcel"
                @DeleteItem="DeleteVestingFromGrid"
              >
                <!-- @EditItem="EditPartner"  -->
              </BaseGrid>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <br>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button type="button" id="btnSave" class="btn btn-primary" :disabled="(!bValidated || pageErrors.length>0 || dataVestingExcel.length<=0)" @click.prevent="SaveBulkVesting">Save</button>
      </div>
      <div class="row no-gutters" style='float: right;'>
          <button type="button" id="btnValidate" class="btn btn-secondary" @click.prevent="validateFn">Validate</button>
        </div>
      <div class="row">
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import BaseModelProgram from '@/models/BaseModelProgram.js';
import BaseModelPartner from '@/models/BaseModelPartner.js';
import BaseModelUnitClass from '@/models/BaseModelUnitClass.js';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import moment from "moment";
import { isNullOrUndefined } from "util";
import _ from "lodash";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import { mapActions, mapState, mapGetters } from "vuex";

import { VestingBulkUploadGridConfig } from "./VestingBulkUploadConfig.js";

import XLSX from "xlsx";
import sheetJSConfig from "@/configs/sheetJS.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
  mixins: [apiUtil, funcUtil,DocumentManagerMixin],
  data() {
    return {
      data: "",
      inputfile: {
        UploadFile: {}
      },
      //UploadFile:excelfile,
      displayPage: false,
      FileUploadType: {
        AllowMultiple: "false"
      },
      SheetJSFT: sheetJSConfig.fileType,
      VestingBulkUploadGridConfig: VestingBulkUploadGridConfig,
      dataVestingExcel: [],
      pageErrors: [],
      Columns:[],
      bValidated:false,
      dropdowns: {
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] }, 
        SpecialArrangement:{ model: "", dataSource: [] },
        UnitPool:{ model: "", dataSource: []}
      },
       bulkUploadAuditConfig: bulkUploadAuditConfig,
    };
  },
  components: {
    BaseGrid,
    Breadcrumb,
    BaseAuditDropzone
  },
  computed: {
    ...mapState("postModule", ["response"]),
    ...mapGetters("getModule", ["getAllItemFilter","withFilter","getLocalInputControls"])
  },
  methods: {
    ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),

    downloadTemplate() {

     let templateUrl = getUrl("VestingEventImport");
     let templateFileName = getFileName("VestingEventImport");
            
      this.$http({
              url: templateUrl,
              method: 'GET',
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });

      window.open(URLS.VestingEventImportTemplate);
    },

    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files);
    },

    backToVesting: function() {
      this.$router.push("/event/vesting");
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        //const XLSX = require("xlsx");
        const self = this;
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) 
          {
              binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary

          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Vesting Data  data */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets["Vesting"];
          const VestingData = XLSX.utils.sheet_to_json(ws, {
            range: sheetJSConfig.template.header - 1,
            header: 1
          });
          console.log(VestingData);
          VestingData.splice(0, 1);
          if (VestingData && VestingData.length) {
            this.displayPage = true;
            //VestingData.splice(0, 1);

            let vestingArr = [];
            let count = 1;
            for (let i = 0; i < VestingData.length; i++) {
              let vestObj = {};
              //console.log(classdata[i])
              vestObj.ProgramID = !isNullOrUndefined(VestingData[i][1])? VestingData[i][0]: null;
              vestObj.PartnerID = !isNullOrUndefined(VestingData[i][3])? VestingData[i][2]: null;

              vestObj.UnitClass = !isNullOrUndefined(VestingData[i][4])? this._firstLetterToUpper(VestingData[i][4]): "";
              vestObj.UnitType = !isNullOrUndefined(VestingData[i][5])? this._firstLetterToUpper(VestingData[i][5]): "";
              vestObj.VestingType = !isNullOrUndefined(VestingData[i][6])? this._firstLetterToUpper(VestingData[i][6]): "";

              vestObj.UnitPool = !isNullOrUndefined(VestingData[i][7])? this._firstLetterToUpper(VestingData[i][7]): "";

              vestObj.VestedDate = self._getExcelPlatformCode(VestingData[i][8]);
              // !isNullOrUndefined(VestingData[i][8])
              //   ? moment(
              //       new Date(
              //         Math.round((VestingData[i][8] - 25569) * 86400 * 1000)
              //       )
              //     ).format("MM/DD/YYYY")
              //   : null;
              vestObj.Percentage = !isNullOrUndefined(VestingData[i][9])? VestingData[i][9]: null;
              vestObj.VestedUnit = !isNullOrUndefined(VestingData[i][10])? VestingData[i][10]: null;
              //vestObj.SpecialArrangement = !isNullOrUndefined(VestingData[i][10])? this._firstLetterToUpper(VestingData[i][10]): "Override";
              vestObj.SpecialArrangement="Override"
              //vestObj.Note = !isNullOrUndefined(VestingData[i][5])? VestingData[i][5]: null;
              vestObj.Status="Pending"
              vestObj.BusinessEvent="Vesting"
              vestObj.VestStartDate =null;
              vestObj.TransactionDate =null;
              vestObj.Unit=null
              vestObj.vestingKey = count++;
              vestingArr.push(vestObj);
            }
            this.dataVestingExcel = vestingArr;
            this.getPartnerDetails();
            this.getProgramDetails();

            let grid = $("#vestingBulkUploadGrid").data("kendoGrid");

            grid.dataSource.data(this.dataVestingExcel);
            console.log(JSON.stringify(this.dataVestingExcel));
          }else{
            this._AlertPopup("Template is Empty","error").then((result) => {
            })
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
        //this.$Progress.fail();
      }
    },
    getPartnerDetails() {
      let partner = this.withFilter(BaseModelPartner.list)
      let dataVesting = this.dataVestingExcel.slice();

      for (let i = 0; i < dataVesting.length; i++) {
        if (dataVesting[i].PartnerID) {
          let result = partner.filter(function(obj) {
            if (obj.PartnerID) {
              return (
                obj.PartnerID.toString()
                  .trim()
                  .toLowerCase() ==
                dataVesting[i].PartnerID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            dataVesting[i].ReceiverFullName = result.FullName;
            dataVesting[i].ReceiverId = result.Id;
          }
        }
      }

      this.dataVestingExcel = dataVesting;
    },
    getProgramDetails() {
            let Program = this.withFilter(BaseModelProgram.list)
            let dataVesting = this.dataVestingExcel.slice();

            for (let i = 0; i < dataVesting.length; i++) {
                if (dataVesting[i].ProgramID) {
                    var result = Program.filter(function (obj) {
                       if(obj.ProgramID)
                        {
                        return (obj.ProgramID.toString().trim().toLowerCase() == dataVesting[i].ProgramID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataVesting[i].ProgramTitle = result.Title;
                        dataVesting[i].ProgramId=result.Id;
                    }
                }
            }
            this.dataVestingExcel = dataVesting;
        },

    DeleteVestingFromGrid: function(e) {
      //e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          let gview = window.$("#vestingBulkUploadGrid").data("kendoGrid");
          let dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          let objIndex = this.dataVestingExcel.findIndex(
            obj => obj.vestingKey == dataItem.vestingKey
          );
          this.dataVestingExcel.splice(objIndex, 1);
          var grid = $("#vestingBulkUploadGrid").data("kendoGrid");
          grid.dataSource.data(this.dataVestingExcel);
        }
      });
    },

    SaveBulkVesting: function() {
      const self = this;
      let BulkVesting = {
        Vesting: {
          config: VestingBulkUploadGridConfig,
          createData: this.dataVestingExcel.slice()
        }
      };
      //this._createAllItems(NewPartnerobject).then(addnewpartner => {
      //let loader = this.$loading.show();
       self._APICrudPopup("APICrudpopup");
      this.CreateAllItems(BulkVesting).then(
        response => {
          console.log(response);
          //self._AlertPopup("Vesting Data Saved Successfully","success");
          /** AUDIT DOCUMENT UPLOAD **/
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
         let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload)
            .then(response => {
              self._AlertPopup("Vesting Data Saved Successfully", "success")
              self.$router.push("/event/vesting");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          /** AUDIT DOCUMENT UPLOAD END */
          this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
        }).catch(error=>{
          self._AlertPopup("Some Error Occurred!","info");
        }).finally(()=>{
          //loader.hide();
      })
    },
    ClearForm() {
      this.dataVestingExcel = [];
      this.pageErrors=[];
      this.bValidated=false;
      this.displayPage = false;
    },
    validateFn(e){
        let self = this;
        e.preventDefault();

        this.bValidated=true;

        let ProgramApiData=self.withFilter(BaseModelProgram.list);
        let PartnerApiDate=self.withFilter(BaseModelPartner.list);
        let ClassApiData=self.withFilter(BaseModelUnitClass.list);

        let dataItem = $("#vestingBulkUploadGrid").data("kendoGrid").dataSource.data();
        self.pageErrors=[];
        let errorMessages = new Set();
        dataItem.forEach((ele,i) => {
        self.Columns = []
        //ProgramID validation
        let programIndex = ProgramApiData.findIndex(f => f.ProgramID == ele.ProgramID)
        if(ele.ProgramID =="" || isNullOrUndefined(ele.ProgramID) || programIndex < 0){
          self.Columns.push({"column":"ProgramID","row":i});
          //self.pageErrors.push("Program ID is Empty or Invalid")
          errorMessages.add("Program ID is Empty or Invalid")
        }
        //PartnerID
        let pIndex = PartnerApiDate.findIndex(f => f.PartnerID == ele.PartnerID)
        if(ele.PartnerID =="" || isNullOrUndefined(ele.PartnerID) || pIndex < 0){
          self.Columns.push({"column":"PartnerID","row":i});
          //self.pageErrors.push("Partner ID is Empty or Invalid")
          errorMessages.add("Partner ID is Empty or Invalid")
        }
        
        //Unit Class
        let unitClassIndex = ClassApiData.findIndex(f => f.UnitClass == ele.UnitClass)
        if(ele.UnitClass =="" || isNullOrUndefined(ele.UnitClass) || unitClassIndex < 0 ){
          self.Columns.push({"column":"UnitClass","row":i});
          //self.pageErrors.push("Unit Class is Empty or Invalid")
          errorMessages.add("Unit Class is Empty or Invalid")
        }

        //UnitType
        let unitTypeIndex = self.dropdowns.UnitType.dataSource.findIndex(f => f.Option == ele.UnitType)
          if(ele.UnitType =="" || isNullOrUndefined(ele.UnitType) || unitTypeIndex < 0 ){
            self.Columns.push({"column":"UnitType","row":i});
            //self.pageErrors.push("Unit Type is Empty or Invalid")
            errorMessages.add("Unit Type is Empty or Invalid")
          } 
        //VestingType
        let vestingTypeIndex = self.dropdowns.VestingType.dataSource.findIndex(f => f.Option == ele.VestingType)
          if(ele.VestingType =="" || isNullOrUndefined(ele.VestingType) || vestingTypeIndex < 0 ){
            self.Columns.push({"column":"VestingType","row":i});
            errorMessages.add("Vesting Type is Empty or Invalid")
          }

        //Unit Pool
        let unitPoolIndex = self.dropdowns.UnitPool.dataSource.findIndex(f => f.Option == ele.UnitPool)
        if(ele.UnitPool =="" || isNullOrUndefined(ele.UnitPool) || unitPoolIndex < 0){
          self.Columns.push({"column":"UnitPool","row":i});
          //self.pageErrors.push("Unit Pool is Empty or Invalid")
          errorMessages.add("Unit Pool is Empty or Invalid")
        }
        
        //Vesting Date
        if (!(ele.VestedDate instanceof Date && !isNaN(ele.VestedDate.valueOf()))) {
           self.Columns.push({"column":"VestedDate","row":i});
           //self.pageErrors.push("Vesting Date is Empty or Invalid")
           errorMessages.add("Vesting Date is Empty or Invalid")
        }
        //Percentage
        if (isNaN(ele.Percentage) || ele.Percentage<=0 || ele.Percentage>1 || isNullOrUndefined(ele.Percentage) || ele.Percentage=="") {
           self.Columns.push({"column":"Percentage","row":i});
           //self.pageErrors.push("Vesting Percentage should be greater than 0 and less than equal to 100")
           errorMessages.add("Vesting Percentage should be greater than 0 and less than equal to 100")
        }
        //Vested Units
        if (isNaN(ele.VestedUnit) || ele.VestedUnit<=0 || isNullOrUndefined(ele.VestedUnit) || ele.VestedUnit=="") {
           self.Columns.push({"column":"VestedUnit","row":i});
           //self.pageErrors.push("Vesting Units should be greater than Zero")
           errorMessages.add("Vesting Units should be greater than Zero")
        }

        //Special Vesting
        let specialArrangementIndex = self.dropdowns.SpecialArrangement.dataSource.findIndex(f => f.Option == ele.SpecialArrangement)
        if(unitTypeIndex < 0 || ele.SpecialArrangement =="" || isNullOrUndefined(ele.SpecialArrangement)){
          self.Columns.push({"column":"SpecialArrangement","row":i});
          //self.pageErrors.push("Special Vesting is Empty or Invalid")
          errorMessages.add("Special Vesting is Empty or Invalid")
        }
        self.Columns.push({ column: "Validation", row: i });
        self.ValidateImportData('vestingBulkUploadGrid',self.Columns)

      })
      self.pageErrors=[...errorMessages]
    },
    getInputControls() {
        let self = this;
        let response = self.getLocalInputControls(BaseModelInputControl.list);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
        });
    }
  },

  mounted() {

    this.getInputControls();
  }
};
</script>

<style>
.dropzone {
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font-size: 16px;
  color: #646464;
  height: 300px !important;
  padding-top: 50px !important;
}
</style>
